// =============================================================================
// IMPORTANT: When adding new VITE_ variables here, also add them to:
// - .github/workflows/deploy.yml (both staging and production env sections)
// =============================================================================

import { createEnv } from "@t3-oss/env-core"
import { z } from "zod"

/**
 * Type-safe environment variables for the admin app.
 * Uses @t3-oss/env-core for runtime validation and type inference.
 *
 * Required variables will throw at startup if missing.
 * Optional variables have type-safe defaults.
 */

export const env = createEnv({
	/**
	 * Client-side environment variables (available in browser).
	 * Must be prefixed with VITE_ to be exposed by Vite.
	 */
	clientPrefix: "VITE_",
	client: {
		// Required
		VITE_CONVEX_URL: z.string().url(),

		// Optional with type validation
		VITE_CHAIN_ID: z.enum(["8453", "84532", "31337"]).optional().default("84532"),
		VITE_RPC_URL: z.string().url().optional(),

		// E2E mode
		VITE_E2E_MODE: z
			.string()
			.optional()
			.transform(val => val === "true"),
	},

	/**
	 * Runtime environment for Vite
	 */
	runtimeEnv: {
		VITE_CONVEX_URL: import.meta.env.VITE_CONVEX_URL,
		VITE_CHAIN_ID: import.meta.env.VITE_CHAIN_ID,
		VITE_RPC_URL: import.meta.env.VITE_RPC_URL,
		VITE_E2E_MODE: import.meta.env.VITE_E2E_MODE,
	},

	/**
	 * Skip validation in certain environments
	 */
	skipValidation: false,

	/**
	 * Empty string handling - treat as undefined
	 */
	emptyStringAsUndefined: true,
})

// =============================================================================
// Backward-compatible exports
// =============================================================================

export const VITE_CONVEX_URL = env.VITE_CONVEX_URL
export const VITE_CHAIN_ID = env.VITE_CHAIN_ID
export const VITE_RPC_URL = env.VITE_RPC_URL
export const E2E_MODE = env.VITE_E2E_MODE
